export default __webpack_public_path__ + "static/media/logo-footer-black.f73f468e.svg";